import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './Header.css';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation(); // 💡 Triggers effect re-evaluations on route transition changes
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [user, setUser] = useState({ username: '', email: '' });
    const API_URL = process.env.REACT_APP_API_URL;
    
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const token = localStorage.getItem('token');
                
                // If there's no token yet (like on public landing/login pages), reset state and stop
                if (!token) {
                    setUser({ username: '', email: '' });
                    return;
                }

                // If user data is already loaded and we have a token, don't keep re-fetching on every page click
                if (user.username) return;

                const response = await axios.get(`${API_URL}/api/user`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                
                if (response.data) {
                    setUser(response.data);
                }
            } catch (error) {
                console.error('Error fetching user data inside global Header wrapper:', error);
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem('token');
                    navigate('/login');
                }
            }
        };

        fetchUserData();
    }, [API_URL, location.pathname, user.username, navigate]); // 💡 location.pathname refires loop when route shifts!

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const handleNavigation = (path) => {
        navigate(path);
        setDropdownOpen(false); // Close dropdown after navigation
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');  // Redirect to login using React Router
    };

    return (
        <header className="header">
            <div className="logo" onClick={() => navigate('/')}>Digicard</div>
            <div className="user-menu">
                <div className="user-info" onClick={toggleDropdown}>
                    <span>{user.username}</span>
                    <span>{user.email}</span>
                </div>
                {dropdownOpen && (
                    <ul className="dropdown-menu">
                        <li onClick={() => handleNavigation('/settings?tab=account')}>Account</li>
                        <li onClick={() => handleNavigation('/settings?tab=subscription')}>Subscription</li>
                        <li onClick={() => handleNavigation('/pricing')}>Upgrade to Pro</li>
                        <li onClick={handleLogout}>Logout</li>
                    </ul>
                )}
            </div>
        </header>
    );
};

export default Header;
